module.exports = require("./is");